import React from "react";

export default function Loading() {
  return (
    <div className="loading">
      <p>Loading...Please wait</p>
    </div>
  );
}
